import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[finaReferenceValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => ReferenceValidatorDirective), multi: true }],
})
export class ReferenceValidatorDirective implements Validator {
    @Input() finaReferenceValidatorPhone: string;
    @Input() finaReferenceValidatorDni: string;

    validate(control: AbstractControl): ValidationErrors | null {
        const value = control.value;

        if (!value) {
            return null;
        }

        // No debe ser '000000'
        if (value === '000000') {
            return { forbiddenZeros: true };
        }

        // No debe ser los últimos 6 dígitos del teléfono
        if (this.finaReferenceValidatorPhone && this.finaReferenceValidatorPhone.length >= 6) {
            const last6Phone = this.finaReferenceValidatorPhone.slice(-6);
            if (value === last6Phone) {
                return { forbiddenPhone: true };
            }
        }

        // No debe ser los últimos 6 dígitos del DNI/RIF (sin la letra inicial)
        if (this.finaReferenceValidatorDni && this.finaReferenceValidatorDni.length >= 6) {
            const numericDni = this.finaReferenceValidatorDni.replace(/[^0-9]/g, ''); // Limpiamos para quedarnos solo con números
            if (numericDni.length >= 6) {
                const last6Dni = numericDni.slice(-6);
                if (value === last6Dni) {
                    return { forbiddenDni: true };
                }
            }
        }

        // ¡La validación éxita!
        return null;
    }
}
